export const warehouseId = 'warehouseId';
export const shippingService = 'shippingService';
export const packageTypeId = 'packageTypeId';
export const confirmationId = 'confirmationId';
export const insuranceProviderId = 'insuranceProviderId';
export const weight = 'weight';
export const dimensions = 'dimensions';
